const BILLION = 1_000_000_000;
const MILLION = 1_000_000;
const THOUSAND = 1_000;

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

export function toPersianDigits(value) {
  return String(value).replace(/\d/g, (d) => PERSIAN_DIGITS[Number(d)]);
}

function trimTrailingZeros(numStr) {
  return numStr.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
}

function buildSuffix(showCurrency, currencySymbol) {
  if (!showCurrency) return '';
  const sym = currencySymbol?.trim();
  if (sym && !['تومان', 'IRR', 'ریال'].includes(sym)) return ` ${sym}`;
  return ' تومان';
}

export function formatPriceToman(amount, { emptyLabel, showCurrency = true, currencySymbol } = {}) {
  const suffix = buildSuffix(showCurrency, currencySymbol);
  const defaultEmpty = suffix ? `۰${suffix}` : '۰ تومان';
  const empty = emptyLabel ?? defaultEmpty;
  const num = Number(amount);

  if (!num || Number.isNaN(num)) return empty;

  if (num >= BILLION) {
    const billions = num / BILLION;
    const label = Number.isInteger(billions) ? String(billions) : trimTrailingZeros(billions.toFixed(2));
    return `${toPersianDigits(label)} میلیارد${suffix}`;
  }

  if (num >= MILLION) {
    const millions = num / MILLION;
    const label = Number.isInteger(millions) ? String(millions) : trimTrailingZeros(millions.toFixed(2));
    return `${toPersianDigits(label)} میلیون${suffix}`;
  }

  if (num >= THOUSAND) {
    const thousands = num / THOUSAND;
    const label = Number.isInteger(thousands) ? String(thousands) : trimTrailingZeros(thousands.toFixed(2));
    return `${toPersianDigits(label)} هزار${suffix}`;
  }

  return `${new Intl.NumberFormat('fa-IR').format(num)}${suffix}`;
}

/** اکنون مثل formatPriceToman عمل می‌کند: «۱۰۰ میلیون تومان» */
export function formatPriceTomanUnitFirst(amount, { emptyLabel, showCurrency = true, currencySymbol } = {}) {
  return formatPriceToman(amount, { emptyLabel, showCurrency, currencySymbol });
}

export function formatMoneyFa(amount, currencySymbol) {
  return formatPriceToman(amount, { currencySymbol: currencySymbol || undefined });
}

export default formatPriceToman;